/**
 * Configuration for Neo-Horizon Client
 *
 * Auth0 SPA login sends one `audience` per authorization request. Horizon server
 * may list multiple API identifiers (comma-separated) in server INI for JWT
 * verification; that format must never be copied into REACT_APP_AUDIENCE here.
 */

/** @param {string | undefined} raw */
function audienceForSpa(raw) {
  if (!raw) return raw;
  const first = String(raw).trim().split(",")[0]?.trim();
  return first || undefined;
}

/** @param {string | undefined} raw @returns {number} clamped 0–100 */
function mixpanelRecordSessionsPercent(raw) {
  if (raw === undefined || raw === null || raw === "") return 0;
  const n = Number.parseInt(String(raw).trim(), 10);
  if (!Number.isFinite(n)) return 0;
  return Math.min(100, Math.max(0, n));
}

const config = {
  domain: process.env.REACT_APP_DOMAIN,
  clientId: process.env.REACT_APP_CLIENT_ID,
  apiUrl: process.env.REACT_APP_API_URL,
  audience: audienceForSpa(process.env.REACT_APP_AUDIENCE),
  launchdarklyClientSideId:
    process.env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID ||
    process.env.REACT_APP_LAUNCHDARKLY_CLIENTSIDE_ID ||
    process.env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDEID,
  mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN,
  /** Session Replay sampling at SDK init; 0 disables replay (Mixpanel default). */
  mixpanelRecordSessionsPercent: mixpanelRecordSessionsPercent(
    process.env.REACT_APP_MIXPANEL_RECORD_SESSIONS_PERCENT,
  ),
  mixpanelExcludeInternalEmails:
    process.env.REACT_APP_MIXPANEL_EXCLUDE_INTERNAL_EMAILS === 'true',
  /** Typeahead suggestions - disabled in prod to avoid API calls when server returns empty */
  typeaheadSuggestionsEnabled: process.env.REACT_APP_TYPEAHEAD_SUGGESTIONS_ENABLED !== 'false',
};

if (!config.launchdarklyClientSideId && process.env.NODE_ENV === 'development') {
  console.warn(
    '⚠️ [Config] LaunchDarkly clientSideID is missing. Most feature flags are unavailable; Billing is shown anyway in dev. Set REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID to use LD for billing.'
  );
}

const requiredFields = ['domain', 'clientId', 'apiUrl', 'audience'];
const missingFields = requiredFields.filter(field => !config[field]);

if (missingFields.length > 0) {
  console.error('Missing required configuration:', missingFields);
  console.error('Make sure environment variables are set from INI files');
}

export default config; 